<template>
  <div class="addAddress absolute">
    <div class="title_nav">
      <div>
        <Icon @click="$router.go(-1)" name="arrow-left" style="margin-top:0.1rem" />
      </div>
      <div class="nav_address">添加收货地址</div>
    </div>
    <div class="list">
      <div class="item acea-row row-between-wrapper">
        <div class="name">姓名</div>
        <input type="text" placeholder="请输入姓名" v-model="userAddress.real_name" required />
      </div>
      <div class="item acea-row row-between-wrapper">
        <div class="name">联系电话</div>
        <input type="text" placeholder="请输入联系电话" v-model="userAddress.phone" required />
      </div>
      <div class="item acea-row row-between-wrapper">
        <div class="name">所在地区</div>
        <div class="picker acea-row row-between-wrapper select-value form-control">
          <div class="address">
            <div slot="right" @click.stop="show2 = true">
              {{ model2 || "请选择收货地址" }}
            </div>
            <CitySelect ref="cityselect" v-model="show2" :callback="result2" :items="district" :ready="ready"
              provance="" city="" area=""></CitySelect>
          </div>
          <div class="iconfont icon-dizhi font-color-red"></div>
        </div>
      </div>
      <div class="item acea-row row-between-wrapper">
        <div class="name">详细地址</div>
        <input type="text" placeholder="请填写具体地址" v-model="userAddress.detail" required />
      </div>
    </div>
    <!-- <div class="default acea-row row-middle">
      <div class="select-btn">
        <div class="checkbox-wrapper">
          <label class="well-check"
            ><input
              type="checkbox"
              name=""
              value=""
              @click="ChangeIsDefault"
              :checked="userAddress.is_default ? true : false"
            /><i class="icon"></i><span class="def">设置为默认地址</span></label
          >
        </div>
      </div>
    </div> -->
    <div class="default acea-row row-middle Splitline">
      <div class="name" style="width:5.5rem">设置为默认地址</div>
      <input class="bty-switch" style="width:1rem" type="checkbox" name="" value="" @click="ChangeIsDefault"
        :checked="userAddress.is_default ? true : false" />
    </div>
    <div></div>
    <div class="keepBnt bg-color-red" @click="submit">保存地址</div>
    <!--  <div class="wechatAddress" v-if="isWechat && !id" @click="getAddress">
      导入微信地址
    </div> -->
  </div>
</template>
<script type="text/babel">
import { CitySelect } from "vue-ydui/dist/lib.rem/cityselect";
import { getAddress, postAddress } from "@api/user";
import { getCity } from "@api/public";
import attrs, { required, chs_phone } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
import { openAddress } from "@libs/wechat";
import { isWeixin } from "@utils";
import { Icon } from "vant";
export default {
  components: {
    CitySelect,
    Icon
  },
  data() {
    return {
      show2: false,
      model2: "",
      district: [],
      id: 0,
      userAddress: { is_default: 0 },
      address: {},
      isWechat: isWeixin(),
      ready: false
    };
  },
  mounted: function () {
    let id = this.$route.params.id;
    this.id = id;
    document.title = !id ? "添加地址" : "修改地址";
    this.getUserAddress();
    this.getCityList();
  },
  methods: {
    getCityList: function () {
      let that = this;
      getCity()
        .then(res => {
          that.district = res.data;
          that.ready = true;
        })
        .catch(err => {
          that.$dialog.error(err.msg);
        });
    },
    getUserAddress: function () {
      if (!this.id) return false;
      let that = this;
      getAddress(that.id)
        .then(res => {
          that.userAddress = res.data;
          that.model2 =
            res.data.province + " " + res.data.city + " " + res.data.district;
          that.address.province = res.data.province;
          that.address.city = res.data.city;
          that.address.city_id = res.data.city_id;
        })
        .catch(err => {
          that.$dialog.error(err.msg);
        });
    },
    getAddress() {
      openAddress().then(userInfo => {
        this.$dialog.loading.open();
        postAddress({
          id: this.id,
          real_name: userInfo.userName,
          phone: userInfo.telNumber,
          address: {
            province: userInfo.provinceName,
            city: userInfo.cityName,
            district: userInfo.countryName
          },
          detail: userInfo.detailInfo,
          is_default: 1,
          post_code: userInfo.postalCode,
          type: 1
        })
          .then(() => {
            this.$dialog.loading.close();
            this.$dialog.toast({ mes: "添加成功" });
            this.$router.go(-1);
          })
          .catch(err => {
            this.$dialog.loading.close();
            this.$dialog.error(err.msg || "添加失败");
          });
      });
    },
    async submit() {
      let name = this.userAddress.real_name,
        phone = this.userAddress.phone,
        model2 = this.model2,
        detail = this.userAddress.detail,
        isDefault = this.userAddress.is_default;
      try {
        await this.$validator({
          name: [
            required(required.message("姓名")),
            attrs.range([2, 16], attrs.range.message("姓名"))
          ],
          phone: [
            required(required.message("联系电话")),
            chs_phone(chs_phone.message())
          ],
          model2: [required("请选择地址")],
          detail: [required(required.message("具体地址"))]
        }).validate({ name, phone, model2, detail });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      try {
        let that = this,
          data = {
            id: that.id,
            real_name: name,
            phone: phone,
            address: this.address,
            detail: detail,
            is_default: isDefault,
            post_code: ""
          };
        postAddress(data)
          .then(function () {
            if (that.id) that.$dialog.toast({ mes: "修改成功" });
            else that.$dialog.toast({ mes: "添加成功" });
            that.$router.go(-1);
          })
          .catch(err => {
            that.$dialog.error(err.msg);
          });
      } catch (e) {
        this.$dialog.error(e.msg);
      }
    },
    ChangeIsDefault: function () {
      this.userAddress.is_default = !this.userAddress.is_default;
    },
    result2(ret) {
      if (ret.itemValue1 == 26 || ret.itemValue1 == 31 || ret.itemValue1 == 84 || ret.itemValue1 == 32 || ret.itemValue1 == 52993) {
        let that = this;

        that.$dialog.toast({ mes: "该地区暂不支持销售" });
        return false;
        console.log('不发货');
      }
      this.model2 = ret.itemName1 + " " + ret.itemName2 + " " + ret.itemName3;
      this.address.province = ret.itemName1;
      this.address.city = ret.itemName2;
      this.address.city_id = ret.itemValue2;
      this.address.district = ret.itemName3;
    }
  }
};
</script>
<style scoped>
.title_nav {
  display: flex;
  width: 100%;
  background: #fff;
  height: 0.7rem;
  padding-left: 0.2rem;
  padding-top: 0.2rem;

}

.nav_address {
  width: 80%;
  text-align: center;
  margin-left: 0.4rem;
}

/* 菜单里的开关，使用type为checkbox的input来做 */
.bty-switch {
  position: relative;
  box-sizing: content-box;
  /* 指定大小和圆角 */
  width: 0.5rem;
  height: 0.4rem;
  border: 1px solid #ccc;
  outline: 0;
  border-radius: .75rem;
  /* 默认的背景色是半透明黑色 */
  background-color: rgba(0, 0, 0, 0.1);
  /* 因为背景颜色和border在选中后发生了改变，所以就在这里加上过渡 */
  transition: background-color .3s, border .3s;
  /* 去掉checkbox的默认样式 */
  -webkit-appearance: none;
  /* 去掉checkbox默认的点击效果 */
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

/* 选中状态下的样式 */
.bty-switch:checked {
  border-color: #07C160;
  background-color: #07C160;
}

/* 把checkbox当成容器来用，里面的圆点用伪元素来做 */
.bty-switch::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  /* 长宽与父级的宽相同，并指定圆角*/
  width: 0.4rem;
  height: 0.4rem;
  border-radius: .7rem;
  background-color: #fff;
  /* 阴影是用来划分边界的 */
  box-shadow: 0 0 2px #999;
  /* 为了让开关有过渡效果，要使用transition属性。这个属性性能消耗大，要避免大规模使用 */
  transition: left 1s;
}

/* 选中状态下，圆点的左边缘位置等于父级宽度减去自己的宽度，这样就靠右了 */
.bty-switch:checked:after {
  left: 0.6rem;
}

.Splitline {
  border-top: 0.01rem solid #eee;
}
</style>
